.wui-floating-panel {
  transform-origin: var(--wui-internal-overlay-transform-origin, center);
  transform: scale(1);
  opacity: 1;
  transition:
    opacity var(--wui-internal-duration-overlay-enter, var(--wui-duration-overlay-enter, 180ms))
      var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1)),
    transform var(--wui-internal-duration-overlay-enter, var(--wui-duration-overlay-enter, 180ms))
      var(--wui-ease-enter, cubic-bezier(0.23, 1, 0.32, 1));
}

.wui-floating-panel[data-wui-presence='entering'],
.wui-floating-panel[data-wui-presence='closing'] {
  transform: scale(var(--wui-scale-enter, 0.97));
  opacity: 0;
}

.wui-floating-panel[data-wui-presence='closing'] {
  pointer-events: none;
  transition-duration: var(--wui-internal-duration-overlay-exit, var(--wui-duration-overlay-exit, 140ms));
}

@media (prefers-reduced-motion: reduce) {
  .wui-floating-panel,
  .wui-floating-panel[data-wui-presence='entering'],
  .wui-floating-panel[data-wui-presence='closing'] {
    transform: none;
    transition-duration: 120ms;
  }
}
